import { theme } from '~/theme';

export default defineAppConfig({
  theme,
  icon: {
    mode: 'css',
    cssLayer: 'base',
  },
  ui: {
    // ─── Runtime color aliases ──────────────────────────────────────────────
    colors: {
      primary: 'primary',
      neutral: 'submarine',
    },

    // ─── Global icon overrides ───────────────────────────────────────────────
    icons: {
      loading: 'material-symbols:sync-rounded',
      close: 'i-octicon-x-24',
      arrowLeft: 'material-symbols:arrow-back-rounded',
      arrowRight: 'material-symbols:arrow-forward-rounded',
    },

    // ─── Toast (was: notifications + notification) ───────────────────────────
    // Note: Toast position is configured via UApp/UToastProvider, not in app.config slots
    // toast: { position: 'top-right' } — configure in the UApp wrapper if needed

    // ─── Alert ───────────────────────────────────────────────────────────────
    alert: {
      defaultVariants: {
        color: 'primary',
      },
    },

    // ─── Card ────────────────────────────────────────────────────────────────
    card: {
      slots: {
        root: 'transition duration-200 shadow-none rounded-card',
        body: 'h-full flex flex-col',
      },
    },

    // ─── Button ──────────────────────────────────────────────────────────────
    button: {
      slots: {
        base: 'font-bold rounded-button',
      },
      variants: {
        size: {
          xl: {
            base: 'py-2.5 gap-x-2.5',
          },
        },
      },
      compoundVariants: [
        {
          color: 'primary',
          variant: 'solid',
          class:
            '!bg-primary-500 hover:!bg-primary-600 active:!bg-primary-600 disabled:!bg-primary-500 aria-disabled:!bg-primary-500 dark:!bg-primary-400 dark:hover:!bg-primary-500 dark:active:!bg-primary-500 dark:disabled:!bg-primary-400 dark:aria-disabled:!bg-primary-400',
        },
      ],
      default: {
        loadingIcon: 'material-symbols:sync-rounded',
      },
    },

    // ─── Badge ───────────────────────────────────────────────────────────────
    badge: {
      slots: {
        base: 'rounded-button',
      },
    },

    // ─── Input ───────────────────────────────────────────────────────────────
    input: {
      slots: {
        base: 'rounded-lg',
      },
      compoundVariants: [
        {
          variant: 'outline',
          class: {
            base: 'shadow-sm bg-white dark:bg-transparent text-black dark:text-white ring-1 ring-inset ring-totem-pole-500 dark:ring-totem-pole-200 focus:ring-2 focus:ring-totem-pole-500 dark:focus:ring-totem-pole-400',
          },
        },
      ],
    },

    // ─── Select ──────────────────────────────────────────────────────────────
    select: {
      slots: {
        base: 'rounded-lg',
      },
    },

    // ─── Textarea ────────────────────────────────────────────────────────────
    textarea: {
      slots: {
        base: 'rounded-lg',
      },
      compoundVariants: [
        {
          variant: 'outline',
          class: {
            base: 'shadow-sm bg-white dark:bg-transparent text-black dark:text-white ring-1 ring-inset ring-totem-pole-500 dark:ring-totem-pole-200 focus:ring-2 focus:ring-totem-pole-500 dark:focus:ring-totem-pole-400',
          },
        },
      ],
    },

    // ─── Checkbox ───────────────────────────────────────────────────────────
    checkbox: {
      slots: {
        base: 'bg-white dark:bg-transparent ring-1 ring-inset ring-totem-pole-500 dark:ring-totem-pole-200 focus-visible:outline-totem-pole-500 dark:focus-visible:outline-totem-pole-400',
        label: 'text-black dark:text-white',
        description: 'text-gray-700 dark:text-gray-300',
      },
    },

    // ─── SelectMenu ─────────────────────────────────────────────────────────
    selectMenu: {
      slots: {
        base: 'rounded-lg',
      },
    },

    // ─── FormField (was: formGroup) ──────────────────────────────────────────
    formField: {
      slots: {
        label: 'text-black dark:text-white',
      },
    },

    // ─── Avatar ──────────────────────────────────────────────────────────────
    avatar: {
      slots: {
        root: 'rounded-button',
      },
    },

    // ─── Breadcrumb ──────────────────────────────────────────────────────────
    breadcrumb: {
      slots: {
        separator: 'material-symbols:chevron-right',
      },
    },

    // ─── Pagination ──────────────────────────────────────────────────────────
    pagination: {
      slots: {
        first: 'rounded-l-button',
        last: 'rounded-r-button',
      },
    },

    // ─── Modal ───────────────────────────────────────────────────────────────
    modal: {
      slots: {
        overlay: 'fixed inset-0 transition-opacity bg-gray-800/75 dark:bg-gray-800/75',
        content: 'bg-white dark:bg-black',
      },
    },
  },
});
